import React from 'react';
import { Loader2Icon, MailIcon } from 'lucide-react';
import { useLeadForm } from '../../hooks/useLeadForm';
import { contact } from '../../data/site';
import { email, required } from '../../utils/validation';
import { Button } from '../ui/Button';
import { TextField } from './fields/TextField';
import { TurnstileSlot } from './TurnstileSlot';
import { FormSuccess } from './FormSuccess';
export function PackForm() {
  const {
    values,
    errors,
    status,
    setField,
    submit
  } = useLeadForm({
    name: '',
    email: ''
  }, {
    name: required('name'),
    email
  });
  if (status === 'success') {
    return <FormSuccess tone="dark" title="The capability pack is on its way." data-id="element-99" data-mp="2q5thgih4nde1">
        Check your inbox at {values.email}. Every brochure and the capability overview are in one email.
      </FormSuccess>;
  }
  return <form onSubmit={submit} noValidate aria-label="Email me the capability pack" className="space-y-4" data-id="element-100" data-mp="3it78y1223gqr">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-101" data-mp="3nlh6a25i3j32">
        <TextField id="pack-name" label="Name" tone="dark" required autoComplete="name" value={values.name} error={errors.name} onChange={value => setField('name', value)} data-id="element-102" data-mp="n9vj1zjpnd6z" />
        <TextField id="pack-email" label="Work email" type="email" tone="dark" required autoComplete="email" value={values.email} error={errors.email} onChange={value => setField('email', value)} data-id="element-103" data-mp="x0zu4o69mdwj" />
      </div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-104" data-mp="120w0gu2fqhf9">
        <TurnstileSlot tone="dark" compact data-id="element-105" data-mp="1fxrk1ggbbr9k" />
        <Button type="submit" disabled={status === 'submitting'} data-id="element-106" data-mp="1ayy83sgoc8bi">
          {status === 'submitting' ? <>
              <Loader2Icon aria-hidden="true" className="h-4 w-4 animate-spin" data-id="element-107" data-mp="3hqz2uzv4wr07" />
              Sending…
            </> : <>
              <MailIcon aria-hidden="true" className="h-4 w-4" data-id="element-108" data-mp="1gnod5l791pz4" />
              Email me the pack
            </>}
        </Button>
      </div>
      {status === 'error' && <p role="alert" className="text-sm text-red-300" data-id="element-109" data-mp="1lovlpmh7ut6u">
          Please check the highlighted fields.
        </p>}
      <p className="text-xs text-white/55" data-id="element-110" data-mp="1unh9bw1joyeh">
        By submitting, you agree to our{' '}
        <a href={contact.privacyUrl} className="underline underline-offset-2 hover:text-white" data-id="element-111" data-mp="1ul4o9a0hq7x7">
          privacy policy
        </a>
        .
      </p>
    </form>;
}